module.exports = __webpack_public_path__ + "img/坐位体前屈视频.4714cad6.png";